/* eslint-disable no-nested-ternary */
/* eslint-disable eqeqeq */
import { theme } from '@mtsbank/ui-kit'
import { ThemeType } from '@shared/types'

const { colors } = theme

export const statuses = {
  default: 'default',
  hover: 'hover',
  active: 'active',
} as const

export type Variants = 'default' | 'privateBanking' | 'premiumBanking' | 'msbAccount' | 'violet'

const getBgColorByStatus = (checked: boolean, variant: Variants, theme: ThemeType) => {
  if (variant == 'privateBanking') {
    return {
      [statuses.default]: checked ? ' rgba(255, 255, 255, 0.2)' : colors.transparent,
      [statuses.hover]: checked ? 'rgba(255, 255, 255, 0.4);' : colors.transparent,
      [statuses.active]: checked ? 'rgba(255, 255, 255, 0.6)' : colors.transparent,
    }
  }
  if (variant == 'premiumBanking') {
    return {
      [statuses.default]: checked ? colors.emerald.primary : colors.white,
      [statuses.hover]: checked ? colors.emerald.hover : colors.white,
      [statuses.active]: checked ? colors.emerald.active : colors.white,
    }
  }
  // if (variant == 'violet') {
  //   return {
  //     [statuses.default]: checked ? colors.violet.primary : colors.white,
  //     [statuses.hover]: checked ? colors.violet.hover : colors.neutral.g700,
  //     [statuses.active]: checked ? colors.violet.primary : colors.neutral.g600,
  //   }
  // }

  return {
    [statuses.default]: checked ? theme.colors.state.active : colors.white,
    [statuses.hover]: checked ? theme.colors.state.hover : colors.neutral.g700,
    [statuses.active]: checked ? theme.colors.state.active : colors.neutral.g600,
  }
}
const getDefaultBorderColor = (variant: Variants, checked: boolean, hasError: boolean, theme: ThemeType) => {
  if (variant === 'privateBanking' || variant === 'premiumBanking') {
    if (checked) return 'transparent'

    return hasError ? colors.orange.primary : colors.neutral.g300
  }

  if (variant === 'violet') {
    if (checked) return 'transparent'

    return hasError ? colors.orange.primary : colors.neutral.g500
  }

  if (checked) return theme.colors.state.active

  return hasError ? colors.orange.primary : colors.neutral.g500
}

const getBorderColorByStatus = (checked: boolean, hasError: boolean, variant: Variants, theme: ThemeType) => {
  if (variant == 'privateBanking' || variant == 'premiumBanking') {
    return {
      [statuses.default]: getDefaultBorderColor('privateBanking', checked, hasError, theme),
      [statuses.hover]: checked ? 'transparent' : colors.neutral.g500,
      [statuses.active]: checked ? 'transparent' : colors.neutral.g300,
    }
  }
  if (variant === 'violet') {
    return {
      [statuses.default]: getDefaultBorderColor('violet', checked, hasError, theme),
      [statuses.hover]: checked ? 'transparent' : colors.neutral.g400,
      [statuses.active]: checked ? 'transparent' : colors.neutral.g300,
    }
  }

  return {
    [statuses.default]: getDefaultBorderColor('default', checked, hasError, theme),
    [statuses.hover]: checked ? theme.colors.state.hover : colors.neutral.g400,
    [statuses.active]: checked ? theme.colors.state.active : colors.neutral.g300,
  }
}

export const getCheckItemBgColor =
  (variant: Variants, status: keyof typeof statuses, theme: ThemeType) =>
  ({ checked, disabled }: { checked?: boolean; disabled?: boolean }) =>
    !disabled
      ? getBgColorByStatus(!!checked, variant, theme)[status]
      : variant == 'default'
      ? colors.neutral.g700
      : checked
      ? variant == 'privateBanking'
        ? colors.neutral.g300
        : colors.neutral.g500
      : colors.transparent

export const getCheckItemBorderColor =
  (variant: Variants, status: keyof typeof statuses, theme: ThemeType) =>
  ({ checked, disabled, hasError }: { checked?: boolean; disabled?: boolean; hasError?: boolean }) =>
    !disabled
      ? getBorderColorByStatus(!!checked, !!hasError, variant, theme)[status]
      : variant == 'default'
      ? colors.neutral.g600
      : variant == 'privateBanking'
      ? colors.neutral.g300
      : colors.neutral.g500

export const getIconColor =
  (variant?: Variants) =>
  ({ disabled }: { disabled?: boolean }) =>
    disabled
      ? variant == 'premiumBanking' || variant == 'violet'
        ? colors.neutral.g400
        : colors.neutral.g500
      : colors.white
